<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="卡名称">
                  <el-input style="width: 186px" v-model="queryForm.cardName"></el-input>
              </el-form-item>
              <el-form-item label="卡次数">
                  <el-input style="width: 186px" v-model="queryForm.cardTimes"></el-input>
              </el-form-item>
              <el-form-item label="卡类型">
                  <!-- <el-input  v-model="queryForm.cardType"></el-input> -->
                <el-select
                  size="small"
                  style="width: 186px"
                  v-model="queryForm.cardType"
                  clearable
                >
                  <el-option
                    v-for="item in auditStatus"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="卡使用限制类型">
                  <!-- <el-input  v-model="queryForm.cardLimit"></el-input> -->
                <el-select
                  size="small"
                  style="width: 186px"
                  v-model="queryForm.cardLimit"
                  clearable
                >
                  <el-option
                    v-for="item in auditStatusLimit"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="queryForm.cardLimit != 1  && queryForm.cardLimit != ''" label="限制次数">
                  <el-input style="width: 186px" v-model="queryForm.limitTimes"></el-input>
              </el-form-item>
              <el-form-item label="可使用目标">
                  <!-- <el-input  v-model="queryForm.cardTarget"></el-input> -->
                <el-select
                  size="small"
                  style="width: 186px"
                  v-model="queryForm.cardTarget"
                  clearable
                >
                  <el-option
                    v-for="item in cardTargets"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="目标ID">
                  <!-- <el-input  v-model="queryForm.targetId"></el-input> -->
                <el-select
                  clearable
                  v-if="queryForm.cardTarget == 1"
                  :disabled="queryForm.cardTarget == ''"
                  style="width: 186px"
                  v-model="queryForm.targetId"
                  placeholder="请选择"
                  size="small"
                >
                  <el-tree
                    :data="cardTargetTree"
                    :props="treeProps"
                  >
                    <div
                      class="custom-tree-node flex items-center"
                      slot-scope="{ node, data }"
                    >
                      <el-option
                        :label="node.label"
                        :value="data.id"
                      > </el-option>
                    </div>
                  </el-tree>
                </el-select>
                <GridSelectLi
                    style="width: 186px"
                    title="选择商品"
                    :disabled="queryForm.cardTarget == ''"
                    labelName="productName"
                    labelValue="id"
                    v-else
                    :value="queryForm.targetId"
                    :limit="1"
                    size="small"
                    placeholder="请选择"
                    @getValue="getSeachValuebrandId"
                    :columns="PRODUCT_code"
                    :searchs="PRODUCT_search"
                    dataListUrl="/shop/product/findList"
                    entityBeanName="shopProduct"
                    queryEntityUrl="/shop/product/get"
                  >
                </GridSelectLi>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopTimescardTypeList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopTimescardType"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editShopTimescardType(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopTimescardType(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportShopTimescardTypeList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopTimescardTypeList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopTimescardTypeList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="cardName"
        label="卡名称"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="cardTimes"
        label="卡次数"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="cardType"
        label="卡类型"
        min-width="180"
      > 
        <template slot-scope="scope">
          {{ computeAuditStatus(scope.row.cardType) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="cardPrice"
        label="卡价格"
        min-width="180"
      > 
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="cardLimit"
        label="卡使用限制类型"
        min-width="180"
      > 
        <template slot-scope="scope">
          {{ computeAuditStatusLimit(scope.row.cardType) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="limitTimes"
        label="限制次数"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="cardTarget"
        label="可使用目标"
        min-width="180"
      >
        <template slot-scope="scope">
          {{ computecardTargets(scope.row.cardTarget) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="targetId"
        label="目标ID"
        min-width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        min-width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopTimescardType(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopTimescardType(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopTimescardType(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopTimescardTypeStates[shopTimescardTypeState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="shopTimescardType"
          ref="shopTimescardTypeForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="卡名称"
            prop="cardName"
          >
            <el-input
              size="small"
              style="width: 186px"
              v-model="shopTimescardType.cardName"
              :disabled="shopTimescardTypeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="卡次数"
            prop="cardTimes"
          >
            <el-input
              size="small"
              style="width: 186px"
              v-model="shopTimescardType.cardTimes"
              :disabled="shopTimescardTypeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="卡类型"
            prop="cardType"
          >
            <!-- <el-input
              size="small"
              v-model="shopTimescardType.cardType"
              :disabled="shopTimescardTypeState == 'check'"
            ></el-input> -->
            <el-select
              size="small"
              style="width: 186px"
              v-model="shopTimescardType.cardType"
              :disabled="shopTimescardTypeState == 'check'"
              clearable
            >
              <el-option
                v-for="item in auditStatus"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="卡价格"
            prop="cardPrice"
          >
            <el-input
              size="small"
              style="width: 186px"
              v-model="shopTimescardType.cardPrice"
              placeholder="请输入卡价格"
              :disabled="shopTimescardTypeState == 'check'"
            />
          </el-form-item>
          <el-form-item
            label="卡使用限制类型"
            prop="cardLimit"
          >
            <!-- <el-input
              size="small"
              v-model="shopTimescardType.cardLimit"
              :disabled="shopTimescardTypeState == 'check'"
            ></el-input> -->
            <el-select
              size="small"
              style="width: 186px"
              v-model="shopTimescardType.cardLimit"
              clearable
              :disabled="shopTimescardTypeState == 'check'"
            >
              <el-option
                v-for="item in auditStatusLimit"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="限制次数"
            prop="limitTimes"
            v-if="shopTimescardType.cardLimit != 1 && shopTimescardType.cardLimit != ''"
          >
            <el-input
              size="small"
              style="width: 186px"
              v-model="shopTimescardType.limitTimes"
              :disabled="shopTimescardTypeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="可使用目标"
            prop="cardTarget"
          >
            <!-- <el-input
              size="small"
              v-model="shopTimescardType.cardTarget"
              :disabled="shopTimescardTypeState == 'check'"
            ></el-input> -->
            <el-select
              size="small"
              style="width: 186px"
              v-model="shopTimescardType.cardTarget"
              :disabled="shopTimescardTypeState == 'check'"
              clearable
            >
              <el-option
                v-for="item in cardTargets"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="目标ID"
            prop="targetId"
          >
            <el-select
                  clearable
                  v-if="shopTimescardType.cardTarget == 1"
                  :disabled="shopTimescardType.cardTarget == '' || shopTimescardTypeState == 'check'"
                  style="width: 186px"
                  v-model="shopTimescardType.targetId"
                  placeholder="请选择"
                  size="small"
                >
                  <el-tree
                    :data="cardTargetTree"
                    :props="treeProps"
                  >
                    <div
                      class="custom-tree-node flex items-center"
                      slot-scope="{ node, data }"
                    >
                      <el-option
                        :label="node.label"
                        :value="data.id"
                      > </el-option>
                    </div>
                  </el-tree>
                </el-select>
                <GridSelectLi
                  style="width: 186px"
                  title="选择商品"
                  v-else
                  :disabled="shopTimescardType.cardTarget == '' || shopTimescardTypeState == 'check'"
                  labelName="productName"
                  labelValue="id"
                  :value="shopTimescardType.targetId"
                  :limit="1"
                  size="small"
                  placeholder="请选择"
                  @getValue="getValuebrandId"
                  :columns="PRODUCT_code"
                  :searchs="PRODUCT_search"
                  dataListUrl="/shop/product/findList"
                  entityBeanName="shopProduct"
                  queryEntityUrl="/shop/product/get"
                >
              </GridSelectLi>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopTimescardTypeState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { PRODUCT, PRODUCT_SEARCH } from '@/utils/constant';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectLi,
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopTimescardTypeList();
                    this.getShopTimescardTypeList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopTimescardTypeList();
                    this.getShopTimescardTypeList();
                    this.$emit('resetCheckState');
                }
            },
            'queryForm.cardLimit':{
                handler(val) {
                    if (val == 1) {
                        this.queryForm.limitTimes = '';
                    }
                },
            },
            'shopTimescardType.cardLimit':{
                handler(val) {
                    if (val == 1) {
                        this.shopTimescardType.limitTimes = '';
                    }
                },
            },
            'queryForm.cardTarget':{
                handler(val) {
                  if(val == ''){
                    this.queryForm.targetId = '';
                  }
                },
            },
            'shopTimescardType.cardTarget':{
                handler(val) {
                  if(val == ''){
                    this.shopTimescardType.targetId = '';
                  }
                },
            },
        },
    data() {
            return {
                queryForm:{
                     cardName: '', //卡名称
                     cardTimes: '', //卡次数
                     cardType: '', //卡类型
                     cardLimit: '', //卡使用限制类型
                     limitTimes: '', //限制次数
                     cardTarget: '', //可使用目标
                     targetId: '', //目标ID
                },
                PRODUCT_code: PRODUCT,
                PRODUCT_search: PRODUCT_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopTimescardTypeState: 'add',
                shopTimescardTypeStates: {
                    add: '新建次卡种类',
                    check: '查看次卡种类',
                    edit: '修改次卡种类'
                },

                multipleSelection: [],
                shopTimescardTypeList: [],
                shopTimescardType: {
                    id: '', //ID
                    cardName: '', //卡名称
                    cardTimes: '', //卡次数
                    cardType: '', //卡类型
                    cardLimit: '', //卡使用限制类型
                    limitTimes: '', //限制次数
                    cardTarget: '', //可使用目标
                    targetId: '', //目标ID
                    cardPrice: '',//卡价格
                },
                btnLoading: false,

                rules: {
                    cardName: [{ required: true, message: '卡名称不能为空', trigger: 'blur' }],
                    cardTimes: [{ required: true, message: '卡次数不能为空', trigger: 'blur' }],
                    cardType: [{ required: true, message: '卡类型不能为空', trigger: 'blur' }],
                    cardLimit: [{ required: true, message: '卡使用限制类型不能为空', trigger: 'blur' }],
                    limitTimes: [{ required: true, message: '限制次数不能为空', trigger: 'blur' }],
                    cardTarget: [{ required: true, message: '可使用目标不能为空', trigger: 'blur' }],
                    targetId: [{ required: true, message: '目标ID不能为空', trigger: 'blur' }],
                    cardPrice: [{ required: true, message: '卡价格不能为空', trigger: 'blur' }],
                },
                treeProps: {
                  children: 'children',
                  label: 'categoryName'
                },
                auditStatus:[],
                auditStatusLimit: [],
                cardTargets: [],
                cardTargetTree: [],
            };
        },
        created() {
            this.getShopTimescardTypeList();
            this.getAuditStatus();
            this.getAuditStatusLimit();
            this.getcardTargets();
            this.getcardTargetTree();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            // 搜索商品
            getSeachValuebrandId(value){
              this.queryForm.targetId = value
            },
            // 商品
            getValuebrandId(value){
              this.shopTimescardType.targetId = value
            },
            getcardTargetTree(query = {}) {
              get(`/shop/productcategory/findAllAsTree`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                  if (res.success) {
                      this.cardTargetTree = res.treeData;
                  }
              });
            },
            getAuditStatus() {
                get('/mpp/utils/getEnum', { enumType: 'times_card_type' }).then((res) => {
                    this.auditStatus = res.enumList;
                });
            },
            computeAuditStatus(type){
                for (let i = 0; i < this.auditStatus.length; i++) {
                    if(this.auditStatus[i].key == type){
                        return this.auditStatus[i].value
                    }
                }
            },
            getAuditStatusLimit() {
                get('/mpp/utils/getEnum', { enumType: 'times_card_limit' }).then((res) => {
                    this.auditStatusLimit = res.enumList;
                });
            },
            computeAuditStatusLimit(type){
                for (let i = 0; i < this.auditStatusLimit.length; i++) {
                    if(this.auditStatusLimit[i].key == type){
                        return this.auditStatusLimit[i].value
                    }
                }
            },
            getcardTargets() {
                get('/mpp/utils/getEnum', { enumType: 'times_card_target' }).then((res) => {
                    this.cardTargets = res.enumList;
                });
            },
            computecardTargets(type){
                for (let i = 0; i < this.cardTargets.length; i++) {
                    if(this.cardTargets[i].key == type){
                        return this.cardTargets[i].value
                    }
                }
            },
            resetShopTimescardTypeList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopTimescardTypeList = [];
            },
            resetDialog() {
                this.shopTimescardTypeState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      cardName: '', //卡名称
                      cardTimes: '', //卡次数
                      cardType: '', //卡类型
                      cardLimit: '', //卡使用限制类型
                      limitTimes: '', //限制次数
                      cardTarget: '', //可使用目标
                      targetId: '', //目标ID
                };
                this.getShopTimescardTypeList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopTimescardType = {
                      cardName: '', //卡名称
                      cardTimes: '', //卡次数
                      cardType: '', //卡类型
                      cardLimit: '', //卡使用限制类型
                      limitTimes: '', //限制次数
                      cardTarget: '', //可使用目标
                      targetId: '', //目标ID
                      cardPrice: '',
                };
            },
            submitForm() {
                if (this.shopTimescardTypeState == 'add') {
                    this.$refs.shopTimescardTypeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            if(this.shopTimescardType.cardLimit == 1){
                              this.shopTimescardType.limitTimes = 0;
                            }
                            post(`/shop/timescardtype/add`,{ ...this.shopTimescardType }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopTimescardTypeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopTimescardTypeState == 'edit') {
                    this.$refs.shopTimescardTypeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.shopTimescardType.product
                            delete this.shopTimescardType.category
                            post(`/shop/timescardtype/edit`,{ ...this.shopTimescardType }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopTimescardTypeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopTimescardType() {
                this.showDialog = true;
                this.shopTimescardTypeState = 'add';
            },
            checkShopTimescardType(shopTimescardTypeId) {
                console.log(shopTimescardTypeId);
                this.currentShopTimescardTypeId = shopTimescardTypeId;

                this.getShopTimescardTypeById();
                this.showDialog = true;
                this.shopTimescardTypeState = 'check';
            },
            editShopTimescardType(shopTimescardTypeId) {
                console.log('shopTimescardType', shopTimescardTypeId);
                if (shopTimescardTypeId) {
                    this.currentShopTimescardTypeId = shopTimescardTypeId;
                    this.getShopTimescardTypeById();
                } else {
                    this.shopTimescardType = { ...this.shopTimescardType, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopTimescardTypeState = 'edit';
            },
            deleteShopTimescardType(shopTimescardTypeId) {
                let ids = '';
                if (shopTimescardTypeId) {
                    ids = shopTimescardTypeId;
                } else {
                    ids = this.multipleSelection.map((shopTimescardType) => shopTimescardType.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/timescardtype/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopTimescardTypeList();
                                this.getShopTimescardTypeList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopTimescardTypeList() {
                this.resetShopTimescardTypeList();
                this.getShopTimescardTypeList();
            },
            getShopTimescardTypeList(query = {}) {
                this.loading = true;
                get(`/shop/timescardtype/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopTimescardTypeList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopTimescardTypeById() {
                get(`/shop/timescardtype/get`,{ id: this.currentShopTimescardTypeId }).then((res) =>{
                    if(res.success){
                      this.shopTimescardType = { ...this.shopTimescardType, ...res.shopTimescardType };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopTimescardTypeList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/timescardtype/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/timescardtype/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/timescardtype/importData`,formData);
              this.refreshShopTimescardTypeList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopTimescardTypeList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopTimescardTypeList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>